export const RECORD_WITH_PLAYBACK_USER_SETTING_KEY = 'recordWithPlayback';
export const SUPPRESS_SVG_CROP_WARNING = 'suppressSvgCropWarning';
export const HIDE_PLAYBACK_WARNING = 'hidePlaybackWarning';
export const HIDE_ELEMENT_NOT_IN_VIEW_WARNING = 'dontShowOutOfCameraWarning';
export const HIDE_ENABLE_COLOR_CHANGE_WARNING = 'dontShowEnableColorChangeWarning';
